<template>
<div class="award">
   <div class="content">
      
      <div class="model">
          <img :src="'/static/images/level'+myawardLevel+'.png'" />
          <div class="text">
              <h1 v-if="myawardLevel==1">恭喜您:获得一等级 金猪一个</h1>
              <h1 v-if="myawardLevel==2">恭喜您:获得二等奖 梦洁乳胶枕一个</h1>
              <h1 v-if="myawardLevel==3">恭喜您:获得三等奖 康巴赫不粘锅一个</h1>
              <h1 v-if="myawardLevel==4">恭喜您:获得幸运奖 乐扣保温杯一个</h1>
              <!-- <h2>{{myawardDate}}</h2> -->
          </div>
          <div class="remark">
              <h3>说明：请在指定时间内到兴盛优选【<span style="color:#ebdede">{{myawardStoreName}}</span>】领取您的奖品</h3>
          </div>
      </div>
   </div>
</div>
</template>
<script>
export default {
   props:["myawardDate","myawardLevel","myawardStoreName"]
}
</script>



// WEBPACK FOOTER //
// src/components/award.vue